<micro-select-combo #sel
              placeholder="Security Protocol"
              [mode]="mode"
              [(id)]="securityProtocol"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              platformService="qd"
>
</micro-select-combo>
